<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { BankProducts } from '~~/server/api/insurance/bank/insurance'

export interface LazyPagesBankInsuranceProducts {
    data: BankProducts
}

const props = defineProps<LazyPagesBankInsuranceProducts>()
</script>
<template>
  <section
    id="bankove-produkty"
    class="scroll-margin-top-11"
  >
    <Box
      decor-position="top-right"
      color="green"
      class="mb-12 mb-md-20"
      padding="px-6 py-10 p-lg-15"
    >
      <BoxHeader
        heading-level="h2"
        :heading="props.data.title"
      />
      <p class="gamma mb-4">
        {{ props.data.subtitle }}
      </p>
      <Typo>
        <div v-html="props.data.description" />
      </Typo>
    </Box>
  </section>
</template>
